// Studyo Today Backend
// Package studyo.today.users.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/resources/identity.proto (package studyo.today.users.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_users_v1_resources_identity_provider } from "./identity_provider_pb.js";

/**
 * Describes the file studyo/today/users/v1/resources/identity.proto.
 */
export const file_studyo_today_users_v1_resources_identity = /*@__PURE__*/
  fileDesc("Ci5zdHVkeW8vdG9kYXkvdXNlcnMvdjEvcmVzb3VyY2VzL2lkZW50aXR5LnByb3RvEh9zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzIm0KCElkZW50aXR5EkwKEWlkZW50aXR5X3Byb3ZpZGVyGAEgASgOMjEuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5JZGVudGl0eVByb3ZpZGVyEhMKC2lkZW50aXR5X2lkGAIgASgJQieqAiRTdHVkeW8uVG9kYXkuVXNlcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_users_v1_resources_identity_provider]);

/**
 * Describes the message studyo.today.users.v1.resources.Identity.
 * Use `create(IdentitySchema)` to create a new message.
 */
export const IdentitySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_resources_identity, 0);

